import { Box, Flex, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { useNamespace } from "~/hooks";
import { useLanguage } from "~/hooks/useLanguage";

import { Phrase } from "../";

function Activate() {
  const { translate } = useNamespace("activate");
  const locale = useLanguage().getCurrentLanguage().locale;

  return (
    <div className="min-w-[520px] max-w-[520px]">
      <Flex direction={"column"} alignSelf="center">
        <Phrase lineHeight={{ base: "30px", md: "70px" }} textAlign={{ base: "center", md: "left" }}>
          {translate("activate@outdoor")}
        </Phrase>
        <Box display={{ base: "none", md: "block" }} color="white" marginTop={"1rem"}>
          {translate("activate@outdoor-description")}
          {locale != "en" && (
            <Button
              as={Link}
              to=""
              onClick={() => {
                if (locale === "pt") window.open("https://fluency.io/br/termos/", "_blank");
                if (locale === "es") window.open("https://fluency.io/es/terminos/", "_blank");
              }}
              variant="terciary"
              color="white"
              textDecoration="underline"
              marginTop="-5px"
            >
              {translate("activate@terms")}
            </Button>
          )}
          {locale != "en" && translate("activate@and")}

          <Button
            as={Link}
            to=""
            onClick={() => {
              switch (locale) {
                case "pt":
                  window.open("https://fluency.io/br/termos/politica-de-privacidade/", "_blank");
                  break;
                case "es":
                  window.open("https://fluency.io/es/terminos/terminos-y-condiciones-de-uso/", "_blank");
                  break;
                case "en":
                  window.open("https://fluency.io/privacy-policy/", "_blank");
                  break;
              }
            }}
            variant="terciary"
            color="white"
            textDecoration="underline"
            marginTop="-5px"
          >
            {translate("activate@privacy")}.
          </Button>
        </Box>
      </Flex>
    </div>
  );
}

export default Activate;
